module.exports = __webpack_public_path__ + "static/media/ilustraThank.be3793d9.png";